// extracted by mini-css-extract-plugin
export var columnList = "_fk-0";